import { useTranslation } from 'react-i18next';

import type { ExternalProviderDescriptor } from '@/types/externalAuth';
import { Button } from '@/components/UI/Button';
import { AuthDivider, ProviderActions, ProviderSection } from '../externalStyles';

type ExternalProviderOptionsProps = {
  mode: 'login' | 'register';
  providers: ExternalProviderDescriptor[];
  disabled?: boolean;
  onSelect: (provider: string) => void;
};

const ExternalProviderOptions = ({
  mode,
  providers,
  disabled = false,
  onSelect,
}: ExternalProviderOptionsProps) => {
  // @ts-ignore i18next's generated key type exceeds this legacy project's compiler depth.
  const { t, i18n } = useTranslation();

  if (providers.length === 0) return null;

  const locale = (['en', 'tc', 'sc'].includes(i18n.language) ? i18n.language : 'en') as 'en' | 'tc' | 'sc';
  const sectionLabel = mode === 'login'
    ? t('pages.auth.external.signInOptions')
    : t('pages.auth.external.registrationOptions');

  return (
    <ProviderSection aria-label={sectionLabel}>
      <AuthDivider>{t('pages.auth.external.continueWith')}</AuthDivider>
      <ProviderActions>
        {providers.map((provider) => (
          <Button
            key={provider.key}
            type="button"
            size="lg"
            variant="primary-invert"
            rounded={false}
            disabled={disabled}
            onClick={() => onSelect(provider.key)}
          >
            {t(mode === 'login' ? 'pages.auth.external.signInWith' : 'pages.auth.external.registerWith', {
              provider: provider.display_name[locale] || provider.display_name.en,
            })}
          </Button>
        ))}
      </ProviderActions>
    </ProviderSection>
  );
};

export default ExternalProviderOptions;
